<template>
  <div class="body_inner">
    <div class="modal-dim on">
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner whole">
          <div class="modal loading-page">
            <!--loading-page 추가-->
            <div class="modal-con">
              <div class="loading-process-page">
                <div class="img-wrap">
                  <svg width="130" height="112" viewBox="0 0 130 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.9457 11.4808C20.9457 11.4808 6.0277 24.6087 3.34245 26.9956C0.6572 29.3825 -0.834604 34.1563 2.14901 37.4382C4.83425 40.7202 7.5195 44.8972 16.172 40.7202C24.8244 36.5431 25.7195 34.4546 27.2113 37.4382C28.7031 40.7202 31.3884 43.7038 31.3884 52.6546C31.3884 61.6054 30.7916 101.586 30.7916 101.586C30.7916 101.586 30.7917 102.481 32.5818 102.481C34.372 102.779 37.0572 103.376 40.0408 103.376C43.0245 103.376 43.3228 102.779 44.2179 101.287C45.113 98.0055 46.6048 83.6842 48.3949 78.612C49.8868 73.5399 49.29 72.0481 52.572 72.0481C56.1523 72.0481 61.2245 75.0317 70.4736 75.6284C73.4573 75.6284 89.8671 76.5235 92.8507 74.7333C95.536 73.2415 94.0442 73.2415 95.8343 78.0153C97.6245 82.7891 99.4147 100.392 100.906 100.989C102.398 101.586 107.769 101.586 109.559 100.989C111.349 100.392 112.543 100.094 112.543 97.7071C112.543 95.3202 113.736 55.6382 112.841 52.6546C112.841 52.6546 112.841 52.6546 112.841 52.3563C112.543 49.0743 112.543 45.494 114.929 46.9858C117.615 48.4776 116.72 53.5497 117.018 56.5333C117.316 59.2186 117.018 72.6448 119.106 73.5399C121.195 74.435 122.388 74.435 123.284 74.1366C124.179 73.8382 125.67 74.1366 125.969 69.9596C126.267 65.7825 128.057 41.9136 123.582 37.4382C120.897 35.0513 114.034 33.2612 111.051 36.8415C109.559 38.0349 108.365 37.1399 108.365 37.1399C106.874 36.2448 105.084 35.0513 103.89 34.1562C92.5524 29.3825 74.9491 32.9628 61.8212 35.0513C58.2409 35.3497 57.9425 33.2612 56.7491 31.471C55.854 29.9792 55.2572 21.3267 45.7097 14.1661C36.1621 7.00541 32.5818 7.30377 29.8966 7.30377C27.5097 7.30377 28.1064 7.90049 28.1064 7.90049C28.1064 7.90049 28.1064 6.70705 28.1064 5.5136C28.1064 4.32016 26.3162 -1.34869 24.2277 0.739834C22.1392 2.82836 21.5425 4.61852 22.1392 7.00541C22.7359 10.2874 20.9457 11.4808 20.9457 11.4808Z"
                      fill="#808080"
                    />
                    <path
                      d="M8.01868 106.718C105.284 88.8162 71.0155 98.7717 129.494 103.247"
                      stroke="#808080"
                      stroke-width="10"
                    />
                    <path
                      class="star"
                      d="M93.1491 36.8415L95.536 41.3169L100.608 42.212L97.0278 45.7923L97.9229 51.1628L93.1491 48.776L88.3753 51.1628L89.2704 45.7923L85.3917 42.212L90.7622 41.3169L93.1491 36.8415Z"
                      fill="#EE3D7F"
                    />
                    <path
                      class="star"
                      d="M71.9654 37.4382L74.3523 42.212L79.4245 43.1071L75.8441 46.6874L76.7392 52.0579L71.9654 49.671L67.1917 52.0579L68.0868 46.6874L64.2081 43.1071L69.5786 42.212L71.9654 37.4382Z"
                      fill="#EE3D7F"
                    />
                    <path
                      class="star"
                      d="M39.1457 18.9398L41.5326 23.7136L46.9031 24.3103L43.0244 27.8907L43.9195 33.2612L39.1457 30.8743L34.372 33.2612L35.267 27.8907L31.6867 24.3103L36.7588 23.7136L39.1457 18.9398Z"
                      fill="#EE3D7F"
                    />
                    <path
                      class="star"
                      d="M46.008 45.1956L48.3949 49.671L53.467 50.5661L49.8867 54.1464L50.7818 59.5169L46.008 57.13L41.2342 59.5169L42.1293 54.1464L38.2506 50.5661L43.6211 49.671L46.008 45.1956Z"
                      fill="#EE3D7F"
                    />
                    <path
                      class="star"
                      d="M98.2213 54.7432L100.608 59.5169L105.979 60.412L102.1 63.9923L102.995 69.3629L98.2213 66.6776L93.7459 69.3629L94.641 63.9923L90.7623 60.412L96.1328 59.5169L98.2213 54.7432Z"
                      fill="#EE3D7F"
                    />
                    <path
                      class="star"
                      d="M68.9819 58.3234L71.3688 63.0972L76.441 63.6939L72.8606 67.5726L73.7557 72.6448L68.9819 70.2579L64.2082 72.6448L65.1032 67.5726L61.2245 63.6939L66.595 63.0972L68.9819 58.3234Z"
                      fill="#EE3D7F"
                    />
                  </svg>
                </div>
                <p>잠시 기다려주세요...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LOADING'
};
</script>
<script setup>
import { computed, getCurrentInstance, ref, watch } from 'vue';
import { useStore } from 'vuex';
const { getters } = useStore();
const { proxy } = getCurrentInstance();

let timer = ref('');

/** watch **/
watch(
  () => proxy.$route,
  val => {
    if (timer) {
      clearTimeout(timer);
      timer = '';
    }
    if (!val) timer = setTimeout(() => {}, 100);
  }
);
</script>
